import { map } from 'lodash'

export default {
  doLoadAll () {
    const search = {
      includes: this.includes,
      ...this.defaultSearch,
      ...this.search
    }
    this.loading = true
    this.$resource.get('', this.prepareSearch(search))
      .then(({data, meta}) => {
        this[this.entities] = map(data, this.prepareShow)
        this.afterPrepareShow()
        this.pagination = meta.pagination
        this.loading = false
      })
      .catch((error) => {
        this.loading = false
        this.afterFailure(error)
      })
  },
  setPage (page) {
    this.search.page = page
    this.doLoadAll()
  },
  prepareSearch (search) {
    return search
  }
}



// WEBPACK FOOTER //
// ./src/crud/index/resources/methods.js